module.exports = __webpack_public_path__ + "static/media/error.18b86d2e.svg";